import gql from 'graphql-tag'

export const GET_SKILL_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getSkillPaginated(
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleKg
        titleRu
        percent
      }
    }
  }
`

export const GET_SKILL_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getSkill (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleKg
      titleRu
      percent
    }
  }
`

export const GET_SKILL_MAIN_QUERY = gql`
  query {
    getSkillMain {
      id
      titleEn
      titleKg
      titleRu
      descriptionEn
      descriptionKg
      descriptionRu
      coverImage
      url
    }
  }
`
